<template>
  <div class="top-ten-brokers-wrap rk-section">
    <MoreTitle title="十大净买入/卖出经纪商">
      <template v-slot:right>
        <i class="iconfont icon-tishishuoming" @click="showMsg('tenBrokers')"></i>
      </template>
    </MoreTitle>
    <div class="edge-padding">
      <div class="update-time">
        <span>{{ updateTime }}</span>
        <span>{{ $t('单位') }}：{{ $t('股') }}</span>
      </div>
      <BtnTabs v-model="active" :data="options[0].map((item) => $t(item.label))" />
      <div class="body">
        <div class="item">
          <div class="net-buy">
            <p class="name">{{ $t('净买入$2') }}</p>
          </div>
          <div class="gap"></div>
          <div class="net-sell">
            <p class="name">{{ $t('净卖出') }}</p>
          </div>
        </div>
        <div v-for="(item, index) in cptBrokerRankValue" :key="index" class="item">
          <div class="net-buy">
            <div class="name">{{ item.buyBrokerName }}</div>
            <div class="bar" v-if="item.buyBrokerName !== '--' && item.buyNetValume !== '--'">
              <div class="label">
                <span>{{ item.buyNetValume }}</span>
              </div>
              <div class="chart" :style="{ width: item.buyPercent, background: item.buyBgColor }"></div>
            </div>
            <div v-else style="width: 100%; text-align: right">--</div>
          </div>
          <div class="gap"></div>
          <div class="net-sell">
            <p class="name">{{ item.sellBrokerName }}</p>
            <div class="bar" v-if="item.sellBrokerName !== '--' && item.sellNetValume !== '--'">
              <div class="chart" :style="{ width: item.sellPercent, background: item.sellBgColor }"></div>
              <div class="label">
                <span>{{ item.sellNetValume }}</span>
              </div>
            </div>
            <div v-else style="width: 100%; text-align: left">--</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RkSwitch from '@/components/common/RkSwitch.vue'
import { showMsg } from '@/plugins/msg'
import BtnTabs from '@/components/common/BtnTabs'
const options = [
  [
    {
      value: 0,
      label: '实时'
    },
    {
      value: 1,
      label: '近1日'
    },
    {
      value: 2,
      label: '近5日'
    },
    {
      value: 3,
      label: '近20日'
    },
    {
      value: 4,
      label: '近60日'
    }
  ]
]
export default {
  components: { BtnTabs, RkSwitch },
  inject: ['theme'],
  data() {
    return {
      popupVisible: false,
      period: options[0][0].value,
      options: options,
      brokerRankValue: {
        buy: [],
        sell: [],
        symbol: ''
      },
      wsparams: {
        market: null,
        params: []
      }
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.symbol.slice(-2)
    },
    cptBrokerRankValue() {
      let result = []

      const { buy = [], sell = [] } = this.brokerRankValue
      const all = [...buy, ...sell]
      if (!all.length) return []
      const maxValue = this.maxInArray(all, 'netVolume')
      const maxLength = Math.max(buy.length, sell.length)

      for (let index = 0; index < maxLength; index++) {
        const buyItem = buy[index] ?? {}
        const sellItem = sell[index] ?? {}

        let { brokerName: buyBrokerName, brokerId: buyBrokerId, netVolume: buyNetValumeRaw } = buyItem
        let { brokerName: sellBrokerName, brokerId: sellBrokerId, netVolume: sellNetValumeRaw } = sellItem

        const buyNetValume = typeof buyNetValumeRaw === 'number' ? buyNetValumeRaw : null
        const sellNetValume = typeof sellNetValumeRaw === 'number' ? Math.abs(sellNetValumeRaw) : null
        const buyPercent = buyNetValume ? (buyNetValume / maxValue) * 100 + '%' : 0
        const sellPercent = sellNetValume ? (sellNetValume / maxValue) * 100 + '%' : 0

        result.push({
          buyNetValume: buyNetValume === null ? '--' : this.$digitjs(buyNetValume).convert(2),
          buyPercent,
          buyBrokerName: buyBrokerName || '--',
          buyBrokerId,
          buyBgColor: this.theme['--main-color-1'],

          sellNetValume: sellNetValume === null ? '--' : this.$digitjs(sellNetValume).convert(2),
          sellPercent,
          sellBrokerName: sellBrokerName || '--',
          sellBrokerId,
          sellBgColor: '#FF4C4C'
        })
      }
      return result
    },
    active: {
      get() {
        const index = this.options[0].findIndex((item) => item.value === this.period)
        return Math.max(0, index)
      },
      set(index) {
        this.period = this.options[0][index].value
      }
    },
    updateTime() {
      let result
      if (this.active === 0) {
        result = `${this.$t('更新')}：${this.brokerRankValue.updateTime ?? '--'}`
      } else {
        result = `${this.$t('数据截至')}：${this.$dayjs(this.brokerRankValue.updateTime).format('YYYY-MM-DD') ?? '--'}`
      }
      return result
      // return this.$dayjs(this.brokerRankValue.updateTime).format('MM/DD HH:mm')
    }
  },
  watch: {
    symbol: {
      immediate: true,
      handler() {
        this.getBrokerStatistics()
      }
    },
    period() {
      this.getBrokerStatistics()
    }
  },
  beforeDestroy() {
    // this.unsubscribeWs(this.wsparams)
  },
  methods: {
    showMsg,
    async getBrokerStatistics() {
      const market = this.market
      const res = await this.$post(this.$api.sdk[market] + `${market === 'hk' ? '' : '/stock/'}/broker/statistics`, {
        size: 10,
        symbol: this.symbol,
        period: this.period
      })
      this.brokerRankValue = res.body ?? {}
      // const params = []
      // params.push(this.$getWsParams({ symbol }, '1018'))
      // this.subscribeWs({ market, params })
    },

    // 订阅WS
    subscribeWs(data) {
      this.unsubscribeWs(this.wsparams)
      const { market, params } = data
      if (!market) return
      params.forEach((item) => {
        this[`$WS${market.toUpperCase()}`].subscribe(this._uid, item[0], this.getWsData)
      })
      this.wsparams = data
    },

    // 退订WS
    unsubscribeWs(data) {
      const { market, params } = data
      if (!market) return
      params.forEach((item) => {
        this[`$WS${market.toUpperCase()}`].unsubscribe(this._uid, item[1])
      })
    },

    getWsData(message) {
      const { buyList: buy, sellList: sell, symbol, updateTime } = message
      this.brokerRankValue = { buy, sell, symbol, updateTime }
    },

    maxInArray(arr, key) {
      if (!(arr instanceof Array)) return 0
      let temp = []
      if (key) {
        arr.forEach((item) => [temp.push(Math.abs(item[key]))])
      } else {
        temp = arr
      }
      return Math.max(...temp)
    }
  }
}
</script>

<style lang="scss" scoped>
$buy-color: #327fff;
$sell-color: #ff8124;
.top-ten-brokers-wrap {
  background: var(--bg-color-2);
  .icon-tishishuoming {
    font-size: 13px;
    color: var(--font-color-3);
    font-weight: 400;
  }
  .update-time {
    font-size: 12px;
    color: #6f7680;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
  }
  .body {
    margin: 0 70px;
    font-size: 12px;
    .item {
      margin: 30px 0;
      display: flex;
      flex-basis: 0;
      justify-content: space-between;
      &:first-of-type {
        margin: 14px 0;

        & + * {
          margin-top: 14px;
        }
      }

      .net-buy,
      .net-sell {
        flex-shrink: 0;
        flex-grow: 0;
        width: 48%;
        .name {
          margin-bottom: 5px;
          color: var(--font-color-1);
          white-space: nowrap; //强制不换行
          overflow: hidden; //超出自动隐藏
          text-overflow: ellipsis; //文字隐藏后添加省略号
        }
        .bar {
          width: 100%;
          display: flex;
          align-items: center;
          .label {
            flex-shrink: 0;
          }
          .chart {
            height: 20px;
            width: 80%;
          }
        }
      }
      .net-buy {
        .name {
          text-align: right;
        }
        .bar {
          justify-content: flex-end;
          .label {
            height: 100%;
            position: relative;
            text-align: right;
            span {
              padding-right: 5px;
              position: absolute;
              right: 0;
              top: 50%;
              transform: translateY(-50%);
              white-space: nowrap;
            }
          }
        }
      }
      .net-sell {
        .bar {
          .label {
            position: relative;
            span {
              padding-left: 5px;
              position: absolute;
              left: 0;
              top: 50%;
              transform: translateY(-50%);
              white-space: nowrap;
            }
          }
        }
      }
    }
  }
  .tips {
    div {
      text-align: left;
      font-size: 12px;
    }
    .title {
      padding: 5px 0 12px 0;
      text-align: center;
      font-size: 14px;
      font-weight: bold;
      color: var(--font-color-1);
    }
    .gap {
      height: 15px;
    }
  }
}
</style>
